
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/songs/[id]",
      function () {
        return require("private-next-pages/songs/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/songs/[id]"])
      });
    }
  